/* eslint-disable spellcheck/spell-checker */
import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';

const SCRIPT_ATTRIBUTES_PER_ENV: Record<
  keyof typeof ENVS,
  Record<string, string>
> = {
  [ENVS.QA]: {
    'data-dtconfig':
      'app=ef522bfead835200|cuc=sopq8vl9|auto=1|cors=1|mel=100000|expw=1|featureHash=ICA15789NPRUVXfqrux|lastModification=1742476712487|reportUrl=https://bf72614kga.bf.dynatrace.com/bf|tp=500,50,0|rdnt=0|uxrgce=1|agentUri=https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js',
    'data-config':
      '{"revision":1743587178228,"beaconUri":"https://bf72614kga.bf.dynatrace.com/bf","agentUri":"https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js","environmentId":"sopq8vl9","modules":"ICA15789NPRUVXfqrux"}',
    'data-envconfig': '{}',
    'data-appconfig': '{"app":"ef522bfead835200"}',
  },
  [ENVS.STAGING]: {
    'data-dtconfig':
      'app=a78d201e47294161|auto=1|cors=1|featureHash=ICA15789NPRUVXfqrux|reportUrl=https://bf24247twu.bf.dynatrace.com/bf|rdnt=1|uxrgce=1|cuc=sw6sw95f|mel=100000|expw=1|dpvc=1|lastModification=1740563755813|tp=500,50,0|agentUri=https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js',
    'data-config':
      '{"revision":1744750721173,"beaconUri":"https://bf24247twu.bf.dynatrace.com/bf","agentUri":"https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js","environmentId":"sw6sw95f","modules":"ICA15789NPRUVXfqrux"}',
    'data-envconfig': '{}',
    'data-appconfig': '{"app":"a78d201e47294161"}',
  },
  [ENVS.PRODUCTION]: {
    'data-dtconfig':
      'app=2c9efb0d298e29ed|auto=1|cors=1|featureHash=ICA15789NPRUVXfqrux|reportUrl=https://bf74291tsy.bf.dynatrace.com/bf|rdnt=1|uxrgce=1|cuc=rieos4aw|mel=100000|expw=1|dpvc=1|lastModification=1740307853936|tp=500,50,0|agentUri=https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js',
    'data-config':
      '{"revision":1744721824832,"beaconUri":"https://bf74291tsy.bf.dynatrace.com/bf","agentUri":"https://js-cdn.dynatrace.com/jstag/1672bab6729/ruxitagent_ICA15789NPRUVXfqrux_10309250310100759.js","environmentId":"rieos4aw","modules":"ICA15789NPRUVXfqrux"}',
    'data-envconfig': '{}',
    'data-appconfig': '{"app":"2c9efb0d298e29ed"}',
  },
};

function getDynatraceScriptName(env: keyof typeof ENVS) {
  if (env === ENVS.QA) {
    return 'qaAgent';
  }

  if (env === ENVS.STAGING) {
    return 'stagingAgent';
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (
    env === ENVS.PRODUCTION &&
    urlParams.get('dynatraceInitialize') === 'true'
  ) {
    return 'productionAgent';
  }
  return undefined;
}

const env = getEnv();
const scriptName = getDynatraceScriptName(env);
const scriptAttributes = SCRIPT_ATTRIBUTES_PER_ENV[env];
if (scriptName && scriptAttributes) {
  const scriptElement = document.createElement('script');

  // Set all attributes dynamically
  Object.entries(scriptAttributes).forEach(([key, value]) => {
    scriptElement.setAttribute(key, value);
  });

  scriptElement.id = 'dynatrace-agent';
  scriptElement.src = `${__webpack_public_path__}${scriptName}.js`;

  document.head.appendChild(scriptElement);
}
